import type { LoanFinancialSnapshotV1 } from './loan-financial.types';
import { buildCollectedRows } from './loan-financial.view-model';
import { Hint, MoneyRow, SectionCard } from './LoanUiBits';

type Props = { snap: LoanFinancialSnapshotV1 };

export function LoanCollectedSummary({ snap }: Props) {
  const rows = buildCollectedRows(snap);
  const hasAny = Number(snap.collected.total ?? 0) > 0;

  return (
    <SectionCard
      title="Cobrado"
      subtitle="Pagos aplicados (excluye anulados). Fuente: financial snapshot."
    >
      {!hasAny ? (
        <p className="text-sm text-slate-500">Aún no se registraron pagos.</p>
      ) : (
        <div className="space-y-1.5">
          {rows.map((r) => (
            <MoneyRow
              key={r.label}
              label={r.label}
              value={r.value}
              emphasis={r.label === 'Total recibido'}
              tooltip={r.tooltip}
            />
          ))}
        </div>
      )}
      {Number(snap.collected.unapplied ?? 0) > 0 ? (
        <p className="mt-2 text-xs text-slate-500">
          Hay crédito no aplicado
          <Hint text="El importe no aplicado queda como crédito del cliente según política." />
        </p>
      ) : null}
    </SectionCard>
  );
}
